import {createSlice} from "@reduxjs/toolkit";
import {STATE_NAMES} from "./StateNames";

const LanguageSlice = createSlice({
    name: STATE_NAMES.LANGUAGES,
    initialState: [],
    reducers: {
        setLanguages: (state, action) => {
            return action.payload;
        },
    },
});

export const { setLanguages } = LanguageSlice.actions;

export default LanguageSlice.reducer;